module.exports = __webpack_public_path__ + "img/Alipay.c400348c.png";